import { ReactNode } from 'react';
import { useMonarchRule } from '@redventures/cohesion-utils-react';
import { ExperienceDataContext } from './ExperienceDataContext';
import type { MonarchEvaluationsValue } from '../../../pages';

interface ExperienceDataProviderProps {
  children: ReactNode;
}

export function ExperienceDataProvider({ children }: ExperienceDataProviderProps) {
  const evaluations = useMonarchRule<MonarchEvaluationsValue>('trafficFlow');
  const experienceData: MonarchEvaluationsValue | undefined = evaluations?.rule
    ?.value as MonarchEvaluationsValue | undefined;

  return (
    <ExperienceDataContext.Provider value={experienceData}>
      {children}
    </ExperienceDataContext.Provider>
  );
}
